import { computed, inject, Injectable, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ListingPageModelAbstract } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model-abstract';
import { ListingPageModel } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { ListingTableComponent } from 'src/app/shared/components/listing-table/listing-table.component';
import { TAB_VALUE } from 'src/app/shared/components/listing-page/listing-page.types';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { ListingPageModelRegistry } from '@portal/shared/components/listing-page/services/listing-page-model/listing-page-model-registry.service';
import { ListingPageId } from '@portal/shared/components/listing-page/store/listing-page-store.types';
import { OrderDirection } from 'src/app/pages/equipment/devices/components/devices.models';
import { RequestProcessingService } from '../services/request-processing.service';
import { RequestProcessingSidePanelTitleComponent } from '../components/request-processing-device-side-panel/request-processing-side-panel-title.component';
import { RequestProcessingDeviceSidePanelComponent } from '../components/request-processing-device-side-panel/request-processing-device-side-panel.component';
import { RequestProcessingListingFiltersSourceService } from './request-processing-listing-filters-source.service';
import { RequestProcessingListingDataSourceService } from './request-processing-listing-data-source.service';
import { RequestProcessingListingExportConfigService } from './request-processing-listing-export-config.service';
import { createRequestProcessingColumns } from './request-processing-listing.columns';
import {
  REQUEST_PROCESSING_DEFAULT_SEARCH_TYPE,
  REQUEST_PROCESSING_SEARCH_TYPES
} from './request-processing-listing.search';
import { REQUEST_PROCESSING_SORT_FIELD } from './request-processing-listing.sort';

@Injectable()
export class RequestProcessingListingModelService extends ListingPageModelAbstract implements ListingPageModel {
  private readonly requestProcessingService = inject(RequestProcessingService);
  readonly listingPageModelRegistry = inject(ListingPageModelRegistry);

  private readonly hasCancelPermission = toSignal(this.requestProcessingService.cancelPermission$, {
    initialValue: false
  });
  private readonly hasRetryPermission = toSignal(this.requestProcessingService.retryPermission$, {
    initialValue: false
  });

  readonly pageTitle = TranslateRegistry.get.MAIN_MENU.TITLE.TWO_WAY_REQUEST_PROCESSING;
  readonly searchTypeList = signal(REQUEST_PROCESSING_SEARCH_TYPES);
  readonly selectedSearchType = signal(REQUEST_PROCESSING_DEFAULT_SEARCH_TYPE);
  readonly sorting = signal({
    columnName: REQUEST_PROCESSING_SORT_FIELD['completedDateTime'],
    orderDirection: OrderDirection.DESC
  });
  readonly tableColumns = computed(() =>
    createRequestProcessingColumns({
      hasCancelPermission: this.hasCancelPermission(),
      hasRetryPermission: this.hasRetryPermission()
    })
  );
  readonly filterSource = inject(RequestProcessingListingFiltersSourceService);
  readonly dataSource = inject(RequestProcessingListingDataSourceService);
  readonly exportConfig = inject(RequestProcessingListingExportConfigService);

  readonly tableCmp = ListingTableComponent;
  readonly defaultTab = TAB_VALUE.Table;
  readonly sortField = REQUEST_PROCESSING_SORT_FIELD;
  readonly selectionFieldName = 'deviceUID';
  readonly sidePanelBodyCmp = RequestProcessingDeviceSidePanelComponent;
  readonly sidePanelTitleCmp = RequestProcessingSidePanelTitleComponent;
  readonly exportButtonVisible = true;

  get pageId(): ListingPageId {
    return ListingPageId.TwoWayRequestProcessing;
  }

  constructor() {
    super();
    this.listingPageModelRegistry.add(ListingPageId.TwoWayRequestProcessing, this);
  }
}
